// ──────────────────────────────────────────────────────────────────────────
// KpiCard.js — Card riusabile per KPI (label + valore + sottotesto).
//
// Estratta da DiarioStatisticheSintesi.js (v130) in v131. Logica e stili
// identici all'originale, byte-per-byte.
//
// Props:
//   - label:       testo della label in alto
//   - valore:      il numero/stringa principale (può essere ReactNode)
//   - sottotesto:  testo aggiuntivo sotto il valore (ReactNode)
//   - colore:      override colore del valore (default: testo primario)
//   - spiega:      props per <SpiegaPopover/> ({titolo, formula, dettagli})
//   - toggleNode:  ReactNode opzionale a destra della label (es. mini-toggle)
// ──────────────────────────────────────────────────────────────────────────

import SpiegaPopover from "./SpiegaPopover";

export default function KpiCard({ label, valore, sottotesto, colore, spiega, toggleNode }) {
  return (
    <div style={{
      background: "#f7f8fa", borderRadius: 10, padding: "14px 16px",
      minHeight: 92, display: "flex", flexDirection: "column",
    }}>
      <div style={{
        fontSize: 12, color: "#6b7280", marginBottom: 6,
        display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <span style={{ display: "inline-flex", alignItems: "center" }}>
          {label}
          {spiega && <SpiegaPopover {...spiega} />}
        </span>
        {toggleNode}
      </div>
      <div style={{
        fontSize: 22, fontWeight: 600,
        color: colore || "#1f2a37", lineHeight: 1.2,
      }}>
        {valore}
      </div>
      {sottotesto && (
        <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 4 }}>
          {sottotesto}
        </div>
      )}
    </div>
  );
}
